import React, { useState } from 'react';

const SearchBar = ({ onSearch }) => {
  const [form, setForm] = useState({
    patientIdentification: 'MR No',
    inputTextField: '',
  });

  const [showSuggestions, setShowSuggestions] = useState(false);

  const getPlaceholder = (identification) => {
    switch (identification) {
      case 'MR No': return 'Enter Patient MR Number';
      case 'Phone': return 'Enter Patient Phone Number';
      case 'Name': return 'Enter Patient Name';
      default: return 'Enter Patient Details';
    }
  };

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const query = form.inputTextField.trim();
      if (query.length >= 0) {
        onSearch && onSearch({
          type: form.patientIdentification,
          query,
        });
        setShowSuggestions(false);
      }
    }
  };

  return (
    <div className="search-bar-container">
      <div className="fused-search-group">
        <select value={form.patientIdentification} onChange={handleChange('patientIdentification')}>
          <option value="MR No">MR No</option>
          <option value="Phone">Phone</option>
          <option value="Name">Name</option>
        </select>

        <div className="find-patient-input-wrapper">
          <input
            type="text"
            placeholder={getPlaceholder(form.patientIdentification)}
            value={form.inputTextField}
            onChange={handleChange('inputTextField')}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
